import type { CSSProperties } from "react";

/** Staggered fade-up animation delay helper. */
export const reveal = (delay: number): CSSProperties => ({ animationDelay: `${delay}ms` });
